import BaseListPresenter from "../../../../../base/BaseListPresenter";
import xhr from "../../../../../usecases/xhr/Xhr";

class BillingListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
    aggregateUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
      aggregateUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.aggregateUseCase = aggregateUseCase;
  }

  init() {
    this.limit = 200;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.filterDate = null;
    this.reset();
  }

  onChangeDate(where) {
    if (Object.keys(where).length > 0) {
      const [key] = Object.keys(where);
      const { $gte, $lte } = where[key];
      this.view.setDateFilter({ gte: $gte, lte: $lte });
    }
    this.filterDate = where;
    this.getObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
      keys: ["name", "code"],
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();

  //   try {
  //     this.findObjectUseCase.abort();

  //     // Fetch all base objects first and show them immediately
  //     const objects = await this.findObjectUseCase.execute(collection, query);
  //     this.objects = objects.map((o) => ({ ...o, credit: 0 }));
  //     this.view.setObjects(this.objects);
  //     this.view.setTotal(this.objects.length);

  //     // Notify UI that we're starting credit loading
  //     this.view.setLoading(true);
  //     this.view.setProgress(0, this.objects.length);

  //     let completed = 0;
  //     const concurrency = 10; // number of parallel requests
  //     const queue = [...this.objects];

  //     const fetchCredit = async (object) => {
  //       try {
  //         const creditObject = await this.findObjectUseCase.execute(
  //           "search_logs",
  //           {
  //             where: { searcher: { affiliate: { id: object.code } } },
  //             keys: ["id"],
  //           }
  //         );
  //         console.log("creditObject", creditObject);
  //         return creditObject?.length || 0;
  //       } catch {
  //         return 0;
  //       }
  //     };

  //     const worker = async () => {
  //       while (queue.length > 0) {
  //         const obj = queue.shift();
  //         if (!obj) return;
  //         const credit = await fetchCredit(obj);
  //         obj.credit = credit;

  //         // update object in UI
  //         const index = this.objects.findIndex((o) => o.code === obj.code);
  //         if (index !== -1) this.objects[index].credit = credit;
  //         this.view.setObjects([...this.objects]);

  //         // update progress bar
  //         completed++;
  //         this.view.setProgress(completed, this.objects.length);
  //       }
  //     };

  //     // Run background workers
  //     await Promise.all(Array.from({ length: concurrency }, worker));

  //     // Done, hide loading and sort
  //     this.view.setLoading(false);
  //     this.objects.sort((a, b) => b.credit - a.credit);
  //     this.view.setObjects(this.objects);
  //   } catch (error) {
  //     this.view.showError(error);
  //   }
  // }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();

  //   try {
  //     this.findObjectUseCase.abort();

  //     const objects = await this.findObjectUseCase.execute(collection, query);
  //     this.objects = objects.map((o) => ({ ...o, credit: 0 }));
  //     this.view.setObjects(this.objects);
  //     this.view.setTotal(this.objects.length);
  //     this.view.setLoading(true);
  //     this.view.setProgress(0, this.objects.length);

  //     const batchSize = 10;
  //     let completed = 0;

  //     for (let i = 0; i < this.objects.length; i += batchSize) {
  //       const batch = this.objects.slice(i, i + batchSize);

  //       // Fetch credits for batch in parallel
  //       const creditPromises = batch.map(async (obj) => {
  //         const creditObject = await this.findObjectUseCase.execute(
  //           "search_logs",
  //           {
  //             where: { searcher: { affiliate: { id: obj.code } } },
  //             keys: ["id"],
  //           },
  //         );
  //         obj.credit = creditObject?.length || 0;
  //         return obj;
  //       });

  //       await Promise.all(creditPromises);

  //       // Update progress
  //       completed += batch.length;
  //       this.view.setProgress(completed, this.objects.length);
  //       this.view.setObjects([...this.objects]);
  //     }

  //     // Final sort
  //     this.objects.sort((a, b) => b.credit - a.credit);
  //     this.view.setObjects(this.objects);
  //     this.view.setLoading(false);
  //   } catch (error) {
  //     this.view.setLoading(false);
  //     this.view.showError(error);
  //   }
  // }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const session = localStorage.getItem("SESSION");

    try {
      this.view.setLoading(true);

      // Fetch affiliates list — NO date filter here, ever.
      // Use a plain query, not this.createQuery() if that builder
      // pulls in the same date-range state used elsewhere.
      const objects = await this.findObjectUseCase.execute(collection, {
        where: { ...this.search },
        sort: { name: 1 },
      });

      this.baseObjects = objects.map((o) => ({ ...o, credit: 0 })); // keep a clean copy
      this.objects = this.baseObjects;
      this.view.setObjects(this.objects);
      this.view.setTotal(this.objects.length);
      const hasValidDateFilter =
        this.filterDate?.createdAt?.$gte && this.filterDate?.createdAt?.$lte;

      if (hasValidDateFilter) {
        await this.loadCredits();
      }
    } catch (error) {
      this.view.setLoading(false);
      this.view.showError(error);
    }
  }

  // Called on initial load AND whenever the date filter changes —
  // never touches the affiliate list, only recomputes/merges credit.
  async loadCredits() {
    const session = localStorage.getItem("SESSION");

    try {
      this.view.setLoading(true);
      this.view.setProgress(0, this.baseObjects.length);

      const hasValidDateFilter =
        this.filterDate?.createdAt?.$gte && this.filterDate?.createdAt?.$lte;

      const dateMatchStage = hasValidDateFilter
        ? [
            {
              $match: {
                $expr: {
                  $and: [
                    {
                      $gte: [
                        "$createdAt",
                        { $toDate: this.filterDate.createdAt.$gte },
                      ],
                    },
                    {
                      $lte: [
                        "$createdAt",
                        { $toDate: this.filterDate.createdAt.$lte },
                      ],
                    },
                  ],
                },
              },
            },
          ]
        : [];

      const logCountsBySearcher = await xhr.aggregate(
        "search_logs",
        [
          ...dateMatchStage,
          { $group: { _id: "$searcher.id", credit: { $sum: 1 } } },
        ],
        { headers: { "X-Session-Token": session } },
      );

      const searcherAffiliates = await xhr.aggregate(
        "users",
        [{ $project: { _id: 1, "affiliate.id": 1 } }],
        { headers: { "X-Session-Token": session } },
      );

      const affiliateBySearcher = new Map(
        searcherAffiliates.map((u) => [u._id, u.affiliate?.id]),
      );

      const creditByAffiliate = new Map();
      for (const { _id: searcherId, credit } of logCountsBySearcher) {
        const affiliateId = affiliateBySearcher.get(searcherId);
        if (!affiliateId) continue;
        creditByAffiliate.set(
          affiliateId,
          (creditByAffiliate.get(affiliateId) || 0) + credit,
        );
      }

      // Merge onto the SAME stable list — never refetch/reshuffle the rows themselves
      // this.objects = this.baseObjects.map((obj) => ({
      //   ...obj,
      //   rates: obj?.rate,
      //   php: (creditByAffiliate.get(obj.code) || 0) * Number(obj?.rate),
      //   credit: creditByAffiliate.get(obj.code) || 0,
      // }));
      this.objects = this.baseObjects.map((obj) => {
        const code = obj.code?.trim();
        const credit = creditByAffiliate.get(code) || 0;
        const rate = Number(obj?.rate) || 0;

        // console.log(`obj.code: ${code}, credit: ${credit}, rate: ${rate}`); // 👈 debug per row

        return {
          ...obj,
          rates: obj?.rate,
          credit,
          php: credit * rate,
        };
      });
      this.objects.sort((a, b) => b.credit - a.credit);

      this.view.setProgress(this.objects.length, this.objects.length);
      console.log("Objects: ", this.objects);
      this.view.setObjects(this.objects);
      this.view.setLoading(false);
    } catch (error) {
      this.view.setLoading(false);
      this.view.showError(error);
    }
  }

  async exportExcel() {
    const session = localStorage.getItem("SESSION");

    if (!this.filterDate?.createdAt?.$gte || !this.filterDate?.createdAt?.$lte) {
      this.view.showError("Please select a date range before exporting.");
      return;
    }

    this.view.setExporting(true);

    const pipeline = [
      {
        $match: {
          $expr: {
            $and: [
              {
                $gte: [
                  "$createdAt",
                  { $toDate: this.filterDate.createdAt.$gte },
                ],
              },
              {
                $lte: [
                  "$createdAt",
                  { $toDate: this.filterDate.createdAt.$lte },
                ],
              },
            ],
          },
        },
      },
      { $sort: { createdAt: -1 } },
      {
        $lookup: {
          from: "users",
          localField: "searcher.id",
          foreignField: "_id",
          as: "searcherDoc",
        },
      },
      { $unwind: { path: "$searcherDoc", preserveNullAndEmptyArrays: true } },
      {
        $lookup: {
          from: "affiliates",
          localField: "searcherDoc.affiliate.id",
          foreignField: "_id",
          as: "affiliateDoc",
        },
      },
      { $unwind: { path: "$affiliateDoc", preserveNullAndEmptyArrays: true } },
      {
        $lookup: {
          from: "branches",
          localField: "searcherDoc.branch.id",
          foreignField: "_id",
          as: "branchDoc",
        },
      },
      { $unwind: { path: "$branchDoc", preserveNullAndEmptyArrays: true } },
      {
        $project: {
          createdAt: 1,
          searched_first_name: 1,
          searched_middle_name: 1,
          searched_last_name: 1,
          searched_alias: 1,
          searched_company: 1,
          "searcher.firstName": "$searcherDoc.firstName",
          "searcher.middleName": "$searcherDoc.middleName",
          "searcher.lastName": "$searcherDoc.lastName",
          "searcher.affiliate": "$affiliateDoc",
          "searcher.branch": "$branchDoc",
        },
      },
    ];

    try {
      const results = await xhr.aggregate("search_logs", pipeline, {
        headers: { "X-Session-Token": session },
      });
      this.view.setExporting(false);
      this.view.onExportReady(results);
    } catch (error) {
      this.view.setExporting(false);
      this.view.showError(error);
    }
  }

  setDateFilter(startDateStr, endDateStr) {
    this.filterDate =
      startDateStr && endDateStr
        ? {
            createdAt: {
              $gte: new Date(`${startDateStr}T00:00:00.000Z`).toISOString(),
              $lte: new Date(`${endDateStr}T23:59:59.999Z`).toISOString(),
            },
          }
        : null;
    this.loadCredits(); // only recompute credit, never refetch the list
  }

  clearDateFilter() {
    this.filterDate = null;
    this.loadCredits();
  }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   const session = localStorage.getItem("SESSION");

  //   try {
  //     this.view.setLoading(true);

  //     // Fetch affiliates list (unchanged)
  //     const objects = await this.findObjectUseCase.execute(collection, query);
  //     this.objects = objects.map((o) => ({ ...o, credit: 0 }));
  //     this.view.setObjects(this.objects);
  //     this.view.setTotal(this.objects.length);
  //     this.view.setProgress(0, this.objects.length);

  //     // Step 1: count logs per searcher — one
  //     //  pass over search_logs, no joins
  //     const dateMatchStage =
  //       this.filterDate && Object.keys(this.filterDate).length > 0
  //         ? [{ $match: this.filterDate }]
  //         : [];

  //     console.log("dateMatchStage", dateMatchStage);

  //     const logCountsBySearcher = await xhr.aggregate(
  //       "search_logs",
  //       [
  //         ...dateMatchStage,
  //         { $group: { _id: "$searcher.id", credit: { $sum: 1 } } },
  //       ],
  //       { headers: { "X-Session-Token": session } },
  //     );

  //     // Step 2: get every searcher's affiliate id — small, cheap projection
  //     const searcherAffiliates = await xhr.aggregate(
  //       "users",
  //       [{ $project: { _id: 1, "affiliate.id": 1 } }],
  //       { headers: { "X-Session-Token": session } },
  //     );

  //     // Step 3: build searcherId -> affiliateId map
  //     const affiliateBySearcher = new Map(
  //       searcherAffiliates.map((u) => [u._id, u.affiliate?.id]),
  //     );

  //     // Step 4: sum credit per affiliate, in memory
  //     const creditByAffiliate = new Map();
  //     for (const { _id: searcherId, credit } of logCountsBySearcher) {
  //       const affiliateId = affiliateBySearcher.get(searcherId);
  //       if (!affiliateId) continue;
  //       creditByAffiliate.set(
  //         affiliateId,
  //         (creditByAffiliate.get(affiliateId) || 0) + credit,
  //       );
  //     }

  //     // Step 5: apply to the affiliates list and sort
  //     this.objects = this.objects.map((obj) => ({
  //       ...obj,
  //       credit: creditByAffiliate.get(obj.code) || 0,
  //     }));
  //     this.objects.sort((a, b) => b.credit - a.credit);

  //     this.view.setProgress(this.objects.length, this.objects.length);
  //     this.view.setObjects(this.objects);
  //     this.view.setLoading(false);
  //   } catch (error) {
  //     this.view.setLoading(false);
  //     this.view.showError(error);
  //   }
  // }
}

export default BillingListPresenter;
